import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const alpaca = defineConnector({
  identifier: "alpaca",
  name: "Alpaca",
  tagLine: "Stock and crypto trading API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "https://paper-api.alpaca.markets"),
  auth: (app) =>
    headerAuth([
      { name: "APCA-API-KEY-ID", value: app.secret.apiKeyId },
      { name: "APCA-API-SECRET-KEY", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Generate API keys",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Alpaca dashboard](https://app.alpaca.markets/), generate an API key pair for paper or live trading.",
        },
      ],
    },
    {
      title: "Enter your Alpaca details",
      items: [
        {
          kind: "url",
          label: "API URL",
          placeholder: "https://paper-api.alpaca.markets",
          helperText:
            "Leave blank for paper trading. Use https://api.alpaca.markets for live trading.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "secrets", field: "apiKeyId" },
        },
        {
          kind: "input",
          label: "API secret key",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://paper-api.alpaca.markets"}/v2/account`,
  },
});
